import { Link } from "react-router-dom";
import type { EventItem } from "@/mocks/events";

type EventCardProps = {
  event: EventItem;
  compact?: boolean;
};

const statusStyle: Record<EventItem["status"], string> = {
  持续跟进: "bg-accent-100 text-accent-900",
  已回应: "bg-secondary-100 text-secondary-900",
  已归档: "bg-background-200 text-foreground-700",
};

export default function EventCard({ event, compact = false }: EventCardProps) {
  return (
    <article className="card-surface group flex h-full flex-col overflow-hidden hover:border-primary-300">
      <Link to={`/topic/${event.id}`} className="block overflow-hidden" aria-label={event.title}>
        <div className={`relative w-full ${compact ? "h-36" : "h-44"} bg-background-200 md:h-48`}>
          <img
            src={event.cover}
            alt={`${event.title} 事件配图`}
            title={`${event.title} · 网络热点事件档案`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
          />
          <span className="absolute left-3 top-3 rounded-md bg-background-50/95 px-2.5 py-1 font-label text-xs font-medium text-primary-700">
            {event.categoryName}
          </span>
        </div>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-2">
          <span className={`rounded-full px-2.5 py-0.5 font-label text-[11px] ${statusStyle[event.status]}`}>
            {event.status}
          </span>
          <span className="font-label text-[11px] text-foreground-500">{event.date}</span>
        </div>
        <h3 className="mt-3">
          <Link
            to={`/topic/${event.id}`}
            className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors duration-200 hover:text-primary-600 md:text-lg"
          >
            {event.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 font-body text-sm leading-relaxed text-foreground-600">
          {event.summary}
        </p>
        <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-background-100 pt-3 font-label text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
            热度 {event.heat}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-3-line text-secondary-500" aria-hidden="true"></i>
            {event.comments} 条讨论
          </span>
          <span className="ml-auto flex items-center gap-1 text-primary-600">
            看脉络
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </article>
  );
}